import { render, staticRenderFns } from "./customerStatistics.vue?vue&type=template&id=caf2b0b8&scoped=true&"
import script from "./customerStatistics.vue?vue&type=script&lang=js&"
export * from "./customerStatistics.vue?vue&type=script&lang=js&"
import style0 from "./customerStatistics.vue?vue&type=style&index=0&id=caf2b0b8&lang=scss&scoped=true&"
import style1 from "./customerStatistics.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf2b0b8",
  null
  
)

export default component.exports